import React from 'react';
import ReactDOM from 'react-dom';
import 'font-awesome/css/font-awesome.min.css'
// import MessengerCustomerChat from 'react-messenger-customer-chat';

import App from './App';

// import { store } from './app/store';
import { store } from "./store/store";
import { Provider } from 'react-redux';

import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from 'react-bootstrap';
import './i18n';

// import Custom Css
import "./assets/css/style.css"
import "./assets/css/color.css"
import "./assets/css/responsive.css"
import "./assets/css/animate.min.css"


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
    <AuthProvider>
      <ThemeProvider dir='ltr'>
      {/* <MessengerCustomerChat pageId="105124045291751" appId="385408413223722" /> */}
      <App />
      </ThemeProvider>
    </AuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();